import FormattedMessage from "@irati/utils/lang"
import React, {FC, useState, useEffect} from "react"
import Flex from "../Flex"
import {Body} from "../Typography"
import {Label, Card} from "./styled"

interface PairText {
  enabled: string
  disabled: string
}

interface Props {
  type: "SingleLabel" | "PairLabels"
  labelState: boolean
  labelColor?: string
  labelText: string | PairText
  notificationText: string | PairText
}

const StatusNotification: FC<Props> = ({type, labelState, labelColor, labelText, notificationText, children}) => {
  const [isEnabled, setLabelState] = useState(labelState)

  let label
  let notification

  if (type === "PairLabels") {
    if (isEnabled) {
      label = labelText.enabled
      notification = notificationText.enabled
    } else {
      label = labelText.disabled
      notification = notificationText.disabled
    }
  }

  useEffect(() => {
    setLabelState(labelState)
  }, [labelState])

  return (
    <Card>
      <Flex justifyContent="space-between" alignItems="center" width="100%" height="53px" margin="30px 0">
        {type === "SingleLabel" && (
          <Flex alignItems="center">
            <Label isEnabled color={labelColor}>
              <FormattedMessage id={labelText} />
            </Label>
            <Body marginLeft={2} maxWidth="100%">
              <FormattedMessage id={notificationText} />
            </Body>
          </Flex>
        )}
        {type === "PairLabels" && (
          <Flex alignItems="center">
            <Label isEnabled={isEnabled} color={labelColor}>
              <FormattedMessage id={label} />
            </Label>
            <Body marginLeft={2} maxWidth="100%">
              <FormattedMessage id={notification} />
            </Body>
          </Flex>
        )}
        {children}
      </Flex>
    </Card>
  )
}

export default StatusNotification
